<template>
  <div class="h-100 w-100 px-5 py-2 main-div">
    <h1 class="main-title">
      What's new in djuli
    </h1>

    <p class="main-subtitle">
      Djuli news feed and release notes
    </p>
    <Release
      version="1.9.1"
      date="19-08-2026"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Fixed report title showing an incorrect number that didn't match the navigation list </li>
      </ul>
    </Release>
    <Release
      version="1.9.0"
      date="25-05-2026"
    >
      <ul>
        <li> Improved Navigation data loading speed and rendering performance </li>
        <li> Streamlined Report list sidebar for a cleaner browsing experience </li>
        <li> Report Viewer graphs now scale responsively across screen sizes </li>
        <li> Enhanced website visibility in search engine results </li>
        <li> Improved page load speed with compression and asset caching </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Resolved unexpected appearance of ghost preprocessing elements </li>
        <li> Fixed TXT file extraction for files with more than 3 columns </li>
      </ul>
    </Release>
    <Release
      version="1.8.24"
      date="07-09-2025"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Recommend Circuit functionality issues </li>
      </ul>
    </Release>
    <Release
      version="1.8.23"
      date="04-08-2025"
    >
      <ul>
        <li> State selector available in Impedance Discrete </li>
        <li> More batch operations in processed files </li>
        <li> Option to change study name </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Linked report issues from IoT sources </li>
      </ul>
    </Release>
    <Release
      version="1.8.22"
      date="09-05-2025"
    >
      <ul>
        <li> Added option to predict a chronometric (AC/PC) graph </li>
      </ul>
    </Release>
    <Release
      version="1.8.21"
      date="06-05-2025"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Multi-redirection fix</li>
        <li> Including extra warnings in case of wrong data in Processed Data table </li>
        <li> Including warnings in case of linked reports </li>
      </ul>
    </Release>
    <Release
      version="1.8.20"
      date="24-04-2025"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Request access pop-up closes immideately when sending</li>
        <li> Tools arrangements </li>
      </ul>
    </Release>
    <Release
      version="1.8.19"
      date="04-04-2025"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Fixed EIS extraction from PSTrace 5.10+</li>
        <li> Avoid nested redirects</li>
      </ul>
    </Release>
    <Release
      version="1.8.18"
      date="31-03-2025"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Fixed UI bug preventing manipulation of measurands </li>
      </ul>
    </Release>
    <Release
      version="1.8.17"
      date="29-01-2025"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Fixing issue of current/reverse current extraction </li>
      </ul>
    </Release>
    <Release
      version="1.8.16"
      date="17-01-2025"
    >
      <ul>
        <li> Datalines containing numbers followd by suffixes ppt, ppb, ppm, ug/L, mg/L, g/L and ugL, mgL, gL auto populates 'group' </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Security fixes </li>
      </ul>
    </Release>
    <Release
      version="1.8.15.1"
      date="12-01-2025"
      :only_bug_fix="true"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Sharing single report false error </li>
        <li> Sharing single with linked data warning </li>
      </ul>
    </Release>
    <Release
      version="1.8.14"
      date="02-01-2025"
    >
      <ul>
        <li> Allow to modify name in datalines of linked files </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Issues in access request from Navigation and ReportViewer </li>
        <li> Removing HTML decorations from tables in some OS </li>
      </ul>
    </Release>
    <Release
      version="1.8.13"
      date="13-11-2024"
    >
      <ul>
        <li> Improving messages on premium partner users </li>
        <li> Improving messages for free users, so they understand better the limitations they have when using djuli </li>
        <li> Implementing in UI the constraint for freemium access for certain premium projects </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Fix templates functionality which was not applied correctly when it contained preprocessing </li>
        <li> Fix small fail when using old type of report previous v1.6 </li>
      </ul>
    </Release>
    <Release
      version="1.8.12"
      date="09-10-2024"
    >
      <ul>
        <li> Comparison reports can be modified. Now you can update the reports that are compared </li>
        <li> Reverse current is now extracted in CSV file too </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Message during removal of dataline because of reverse current fixed</li>
      </ul>
    </Release>
    <Release
      version="1.8.11"
      date="10-09-2024"
    >
      <ul>
        <li> Added three new preprocessing technieques: Differentiation, accumulation and outlier rejection </li>
      </ul>
    </Release>
    <Release
      version="1.8.10"
      date="16-07-2024"
    >
      <ul>
        <li> Range selection of reports by dash when linking reports</li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Extraction issue on reverse current for newer version of pssession</li>
        <li> Small fixes around linking reports on animation and autosave on first creation</li>
      </ul>
    </Release>
    <Release
      version="1.8.9"
      date="24-06-2024"
    >
      <ul>
        <li> Report files link. This connects multiple reports to retrieve the extracted data files </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Optimizations while loading Navigation information to avoid extra requests</li>
        <li> Fixing small style issues</li>
      </ul>
    </Release>
    <Release
      version="1.8.8"
      date="24-05-2024"
    >
      <ul>
        <li> Including list of known users when sharing cluster and reports </li>
        <li> Scroll to top functionality (a little gree arrow on the right side of the page)</li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Esthetic fix on the Report List sidebar</li>
        <li> Including extra label on duplicate cluster</li>
      </ul>
    </Release>
    <Release
      version="1.8.7"
      date="14-05-2024"
    >
      <ul>
        <li> Including IoT julia configuration parsing </li>
        <li> Optimizations on the configuration loading </li>
      </ul>
    </Release>
    <Release
      version="1.8.6"
      date="14-04-2024"
    >
      <ul>
        <li> Including alternative units functionality </li>
        <li> Including views in clusters. Active, Favorites, Archived and All</li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Changing values in the processed table doesn't remove the current filter</li>
      </ul>
    </Release>
    <Release
      version="1.8.5"
      date="15-02-2024"
    >
      <ul>
        <li> Re-introduced standard-addition for continuous studies </li>
        <li> Improved efficincey of extraction nested raw files </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Bug with chrono configuration window when data comes from IoT </li>
      </ul>
    </Release>
    <Release
      version="1.8.4"
      date="09-02-2024"
    >
      <ul>
        <li> New preprocessing method allows you to extrapolate raw data curves </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Deletion of multiple reports no longer promts multiple confimarion dialogs </li>
        <li> Fixed mismatch  </li>
      </ul>
    </Release>
    <Release
      version="1.8.2"
      date="05-02-2024"
    >
      <ul>
        <li> Added support for PalmSens Sensit Smart data structure </li>
        <li> Improved efficincey for nested file structures </li>
      </ul>
    </Release>
    <Release
      version="1.8.1"
      date="31-01-2024"
    >
      <ul>
        <li> Added button for downloading raw data as CSV </li>
      </ul>
    </Release>
    <Release
      version="1.8.0"
      date="25-01-2024"
    >
      <ul>
        <li> Added standard addition functionality to discrete studies </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Removed standard addition from continuous studies </li>
      </ul>
    </Release>
    <Release
      version="1.7.2"
      date="12-11-2023"
    >
      <ul>
        <li> Including scalex and scaley on the terminal commands </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Fix on misalignment on the up arrow while working on the Terminal</li>
      </ul>
    </Release>
    <Release
      version="1.7.1"
      date="24-09-2023"
    >
      <ul>
        <li> Improvements on reviewers functionality </li>
        <li> Improving links on Access Request based on feedback </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Issues on saving shared reports</li>
        <li> Issues when opening IoT reports because of missing information. Making more robust the file processing</li>
      </ul>
    </Release>
    <Release
      version="1.7.0"
      date="17-09-2023"
    >
      <ul>
        <li> Main navigation user experience changed to tabular ag grid features </li>
        <li> Clusters, Projects and Reports summary info  added </li>
        <li> Send access request for an authorized report</li>
        <li> Breadcrumb features on all tabular navigation pages </li>
        <li> Resource Access Request Management </li>
      </ul>
    </Release>
    <Release
      version="1.6.12"
      date="16-08-2023"
    >
      <ul>
        <li> Raw data from multiple reports can now be downloaded with one action! </li>
      </ul>
    </Release>
    <Release
      version="1.6.11"
      date="07-08-2023"
    >
      <ul>
        <li> Added support for uploading SenseItAll data files </li>
        <li> More detailed pricing information </li>
      </ul>
    </Release>
    <Release
      version="1.6.10"
      date="30-07-2023"
    >
      <ul>
        <li> Added offset preprocessing </li>
        <li> Added flip preprocessing </li>
        <li> Added option for peak valley detection </li>
      </ul>
    </Release>
    <Release
      version="1.6.9"
      date="29-07-2023"
    >
      <ul>
        <li> Legend items in plots limited to showing 30 characters </li>
        <li> Better scaling of EIS Nyquist plot </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> ID plots could not be redered unless Circuit Fit was enabled</li>
      </ul>
    </Release>
    <Release
      version="1.6.8"
      date="16-06-2023"
    >
      <ul>
        <li> Introduced dilution factor </li>
        <li> Enabled custom coefficients for Log-Log fit </li>
      </ul>
    </Release>
    <Release
      version="1.6.7"
      date="16-06-2023"
    >
      <ul>
        <li> Extracting .pssession data format of any type of key-value data format (case insensitive) </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Data formats (e.g PST594515 version) with keys having non-lowercase case formats are accomodated. </li>
        <li> Any type and level of nested key-value data formating can be handled in the future. </li>
      </ul>
    </Release>
    <Release
      version="1.6.6"
      date="24-04-2023"
    >
      <ul>
        <li> Allowing to select multiple states in all the studies.</li>
        <li> Animation when deleting element. </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Issue in state and group in Proccessed data table fixed. </li>
        <li> Removing disabled Interactive configuration buttons. </li>
        <li> Newest template is set to the top of the list. </li>
        <li> Allowing duplicate analyzes when exporting Processed data. </li>
      </ul>
    </Release>
    <Release
      version="1.6.5"
      date="05-04-2023"
    >
      <ul>
        <li> Cluster sorting is now alphabetical </li>
      </ul>
    </Release>

    <Release
      version="1.6.4"
      date="04-04-2023"
    >
      <ul>
        <li> Bugfix for comparative report not rendering upon creation </li>
        <li> Bugfix for processed data export error when similar study names </li>
        <li> Bugfix for general notation and unit not carrying over to all visual components </li>
        <li> Report name now shows in title bar </li>
        <li> Nonlinear curve fitting is now much faster </li>
      </ul>
    </Release>

    <Release
      version="1.6.3"
      date="13-03-2023"
    >
      <ul>
        <li> Improved handling of equivalent circuit fiting </li>
      </ul>
    </Release>


    <Release
      version="1.6.2"
      date="10-03-2023"
    >
      <ul>
        <li> Minor bugfixes </li>
      </ul>
    </Release>

    <Release
      version="1.6.1"
      date="06-03-2023"
    >
      <ul>
        <li> Minor bugfixes </li>
      </ul>
    </Release>

    <Release
      version="1.6.0"
      date="04-03-2023"
    >
      <ul>
        <li> Option for searching scientific literature for equivalent circuit matching EIS data </li>
        <li> Major improvements to EIS comoponent visualization </li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Fixed rendering of equivalent drawing inside tools menu. </li>
        <li> Fixed that some values changed under tools do not register in the final configuration </li>
      </ul>
    </Release>

    <Release
      version="1.5.8"
      date="19-02-2023"
    >
      <ul>
        <li>Standard Addition functionality</li>
        <li>Upgrade of back-end infrastructure</li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Fixed: Terminal --help command and style updated. </li>
      </ul>
    </Release>

    <Release
      version="1.5.7"
      date="17-02-2023"
    >
      <ul>
        <li>Bugfixes</li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> CH Instruments files are now segmented into separate datalines if cyclic. </li>
      </ul>
    </Release>



    <Release
      version="1.5.6"
      date="04-02-2023"
    >
      <ul>
        <li>Version aligned to new dynamic structure of the back-end</li>
      </ul>
    </Release>
    <Release
      version="1.5.5"
      date="09-01-2023"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Fixed: Report freezing when too many resize operations. </li>
      </ul>
    </Release>

    <Release
      version="1.5.4"
      date="03-01-2023"
    >
      <ul>
        <li> Added support for square root curve fitting </li>
      </ul>
    </Release>

    <Release
      version="1.5.3"
      date="02-01-2023"
    >
      <ul>
        <li> Added support for Biologics Excel export files</li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Impedance Discrete cricuit fit: Removed remnant reference to initial values  </li>
      </ul>
    </Release>

    <Release
      version="1.5.2"
      date="30-12-2022"
    >
      <h4>Bugfixes</h4>
      <ul>
        <li> Impedance Discrete: Removed remntant references to initial-guess</li>
        <li> Styling fix for wrapped text </li>
      </ul>
    </Release>

    <Release
      version="1.5.1"
      date="11-12-2022"
    >
      <ul>
        <li> Removed initial guess controllers in circuit fit. </li>
      </ul>
    </Release>

    <Release
      version="1.5.0"
      date="09-12-2022"
    >
      <ul>
        <li>Changed optimization mode for circuit fit. This improves fitting a lot, removes the need for initial guess, but takes longer (10-25x)</li>
      </ul>
      <h4>Bugfixes</h4>
      <ul>
        <li> Impedance Discrete: Fixewd wrong representation of complex phase plot in (ID)</li>
        <li> Spatial heat map: Changed residual to relative residual, as indicated in plot title </li>
        <li> Feature check only working for time series </li>
      </ul>
    </Release>
    <Release
      version="1.4.4"
      date="25-11-2022"
    >
      <ul>
        <li>We have added ADDONs services</li>
        <li>Checkout Universal Data Converter</li>
        <li>Checkout Design of experiement</li>
      </ul>
    </Release>

    <Release
      version="1.4.3"
      date=""
    >
      <ul>
        <li>Added delta checks for Feature Check</li>
      </ul>
    </Release>


    <Release
      version="1.4.3"
      date=""
    >
      <ul>
        <li>Added support for decomposed SWV in PSTrace 5.9+</li>
        <li>Added difference mode for Feature Check</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li> None </li>
      </ul>
    </Release>

    <Release
      version="1.4.2"
      date=""
    >
      <ul>
        <li>Introduce Add-on services</li>

        <li>Integrated Universal Data Converter(UDC)</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Fixed the incorrect file size display</li>
      </ul>
    </Release>

    <Release
      version="1.4.1"
      date=""
    >
      <ul>
        <li>Allowing multiple studies of the same type</li>

        <li>Updating packages</li>

        <li>Increasing speed when opening a report</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Extraction of data from pss file types in correct form</li>

        <li>Fixing issues on Mozila Firefox</li>
      </ul>
    </Release>

    <Release
      version="1.4.0"
      date=""
    >
      <ul>
        <li>
          Added option to supply custom coefficients for prediction
          model
        </li>

        <li>
          Optimized prediction algorithms for reliability and speed
        </li>

        <li>Changed from a flat to nested payload configuration</li>

        <li>
          Introduced .hola files as a means to directly supplying the
          payload to the file uplad interface
        </li>

        <li>Made tools secton only one level deep</li>

        <li>Added more robustness to peak finding</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Autoscaling of graphs, despite passing axis limits</li>

        <li>Categorical x axis for box and violin plots</li>

        <li>Wrong naming in preprocessing table for some elements</li>

        <li>Range processing had elements swapped</li>
      </ul>
    </Release>

    <Release
      version="1.3.9"
      date=""
    >
      <ul>
        <li>Placeholder</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Placeholder</li>
      </ul>
    </Release>

    <Release
      version="1.3.8"
      date="04-05-2022"
    >
      <ul>
        <li>
          Added an option to group continuous datalines for comparison
          within a report.
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Updated column header to match general metric</li>
      </ul>
    </Release>

    <Release
      version="1.3.7"
      date="01-05-2022"
    >
      <ul>
        <li>Confirmation to download multiple files.</li>

        <li>
          Area of Interest and Concentration definition plot the preprocessed
          data.
        </li>

        <li>Homogenization of the order of the fit parameters.</li>

        <li>Optimizing feature extract in the back-end.</li>

        <li>Raw data is scaled the same as preprocessed.</li>

        <li>Raw data is scaled the same as preprocessed.</li>

        <li>Added option for grouping discrete data.</li>

        <li>
          Feature check and color order for raw data to match
          statistics.
        </li>

        <li>
          Violin plot included for Statistical Evaluation. Swapped box
          plot for violin.
        </li>

        <li>
          More features to extract special cases of psession files.
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Data sorting problem in exponential notation in tables.</li>

        <li>Issue with oversized sections in Report Viewer.</li>

        <li>Modifying processing order of arguments.</li>

        <li>
          Histogram starts at 0 in statistical analysis and style of data
          presentation.
        </li>
      </ul>
    </Release>

    <Release
      version="1.3.6"
      date="05-04-2022"
    >
      <ul>
        <li>Changing time stamp for IoT data analysis</li>

        <li>Style changes for the raw graph and histograms</li>

        <li>Added trace name to feature check</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Histograms do not have to start at x = 0</li>

        <li>Matched colors in statistics and raw data</li>

        <li>Error while downloading large raw files</li>
      </ul>
    </Release>

    <Release
      version="1.3.5"
      date="03-04-2022"
    >
      <ul>
        <li>Tables in the reports are scrollables</li>

        <li>
          User can change width of Histogram in Statistical Evaluation
          for Discrete studies.
        </li>

        <li>The data source of a report can be a third party API.</li>

        <li>Changing defult layout of the Wafer Mapping.</li>

        <li>The histogram restyling and bin size optimization.</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Oversizing tables with more than 20 entries</li>

        <li>Image processing algorithm warning without details.</li>

        <li>
          Including more validation during extraction of pssession
          files.
        </li>
      </ul>
    </Release>

    <Release
      version="1.3.4"
      date="30-03-2022"
    >
      <ul>
        <li>Adding Nitrate analysis from IoT functionality.</li>

        <li>
          Color palette change for charts with more than 12 elements.
        </li>

        <li>The peak search algorithm is more robust.</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>"Range" preprocessing is activated again.</li>

        <li>
          Error in Comparative Report when the statistical evaluation
          is not present.
        </li>

        <li>DT6 bug with new back-end service.</li>
      </ul>
    </Release>

    <Release
      version="1.3.3"
      date="23-03-2022"
    >
      <ul>
        <li>
          Changing default values for Iterative Polynomial Baseline.
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Extra with the Savitzky-Golay preprocessing.</li>

        <li>Adding validations in the analysis backend.</li>
      </ul>
    </Release>

    <Release
      version="1.3.2"
      date="6-03-2022"
    >
      <ul>
        <li>Extracts more structures of CSV files.</li>

        <li>Extracts more structures of XSLX files.</li>

        <li>
          Direct communication with File Storage for faster file transfer.
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Minor functionality bugs in Processed Data.</li>

        <li>Minor functionality defining the State values.</li>
      </ul>
    </Release>

    <Release
      version="1.3.1"
      date="23-02-2022"
    >
      <ul>
        <li>Redirection of Contact Us to external link.</li>

        <li>Increasing validations in the subscription payment.</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Minor functionality bugs in subscription.</li>
      </ul>
    </Release>

    <Release
      version="1.3.0"
      date="7-02-2022"
    >
      <ul>
        <li>
          Integration with new optimized structure in the djuli analysis
          motor.
        </li>

        <li>
          Impedance study formating. Changing graphs axis and default
          circuit.
        </li>

        <li>Analysis of fitted components in Impedance study.</li>

        <li>
          "Feature check" and "Show extracted values" available for all
          the studies.
        </li>

        <li>Showing "State" in Processed Data table</li>

        <li>
          "Component" and "Unit" included in the statistical evaluation
          of Impedance Study
        </li>

        <li>Axis 1:1 Scale for Nyquist Graph in Impedance Fit</li>

        <li>
          Annotations for the concentrations in the Continuous Studies
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>
          Increased specificity of warning messages and errors during
          analysis.
        </li>

        <li>Bug fixing feature check.</li>

        <li>Moving Fit Equation to all the studies.</li>

        <li>Issue with legends group in Impedance Study</li>

        <li>PDF export overlapping</li>

        <li>
          Changing location of Circuit Draw in Impedance Study result
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.10"
      date="23-01-2022"
    >
      <ul>
        <li>
          Optimizing the argmin algorithm applied in Discrete Studies.
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Validation of new reports added from IoT.</li>

        <li>
          Removing unnecessary warnings when the analysis was not performed
          successfully.
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.9"
      date="10-01-2022"
    >
      <ul>
        <li>
          Functionality of "Show Extracted Values" in Continuous
          Studies.
        </li>

        <li>Support for the Autolab CSV files.</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>
          DT6 extraction. When djuli does not recognize values in the
          DT6, extract all current and potential columns.
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.8"
      date="19-12-2021"
    >
      <ul>
        <li>
          Supporting import of HTML files with single plotly graph
        </li>

        <li>
          Alpha version of Generic Discrete and Continuous Studies
        </li>

        <li>Moving units within the configuration of the study</li>

        <li>Supporting files with the TRM extension</li>

        <li>Adding feature check to all discrete studies</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>
          Removing the configuration section within report when the study
          is deleted
        </li>

        <li>
          Changing text to a shorter version in the study selection, and
          cleaning style
        </li>

        <li>
          If the report contains multiple studies. When one study fails,
          try the others
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.7"
      date="23-11-2021"
    >
      <ul>
        <li>Autosaving the report after five minutes</li>

        <li>Autosaving the report before automatic logout</li>

        <li>
          Adding button to alter multiple concentrations in the Processed
          Data Table
        </li>

        <li>The short id is displayed next to the report title</li>

        <li>Confirmation before leaving a modified report</li>

        <li>Larger toolbox</li>

        <li>
          Allowing connection with the new structure of the back-end
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>
          Showing the notification that the session will expire for three
          minutes before automatically logging out
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.6"
      date="7-11-2021"
    >
      <ul>
        <li>Beta version of cluster mirroring.</li>

        <li>
          Viewer/Editor functionality activated when sharing report or
          cluster.
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>
          Error selecting multiple reports to share with common users.
        </li>

        <li>
          Inconsistances in the report table with the Navigation and Report
          Viewer.
        </li>

        <li>
          "More options" drop-down menu and text message in Report Viewer
          style
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.5"
      date="1-11-2021"
    >
      <ul>
        <li>
          Alpha version of cluster mirroring. Allows you to share reports
          individually. Only owners can share
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.3"
      date="26-10-2021"
    >
      <ul>
        <li>
          Changing the cluster and project selection flow in the navigation
          section. Preparing for cluster mirroring.
        </li>

        <li>Separating the scroll in navigation section</li>

        <li>
          The reports have contiguous numerical identification in the
          project.
        </li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>DT6 extraction for single-column data.</li>

        <li>
          The study Impedance Discrete presents the control for the selection
          of the equation fit.
        </li>
      </ul>
    </Release>

    <Release
      version="1.2.2"
      date="25-10-2021"
    >
      <ul>
        <li>
          Changing report text fields and style. 'Description' and 'Purpose'
          is moved to 'Details.'
        </li>

        <li>
          The elements denoted with an asterisk (*) are encouraged to
          be filled out.
        </li>

        <li>The uncomplete reports are denoted with the 📝 icon</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>Changing the text in the confirmation pop-up</li>

        <li>When the session expires, it logs out automatically.</li>
      </ul>
    </Release>

    <Release
      version="1.2.1"
      date="20-10-2021"
    >
      <ul>
        <li>New version of learning mode</li>

        <li>Release notes are available</li>

        <li>Version beta of Feature Check</li>

        <li>Pictures includes file name as title</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>
          Solving problem with of units in the EIS circuit fitting
        </li>

        <li>Properties in the Tools are expanded by default</li>

        <li>Raw data is enabled by default</li>

        <li>Hold of learning mode is supported on Mac</li>

        <li>
          Hide dropdown menu does not interfere with Plotly graphs in
          Report Viewer
        </li>

        <li>
          Bug fixes in the Area of Interest and Chrono configuration
        </li>

        <li>Style in the sharing window</li>
      </ul>
    </Release>

    <Release
      version="1.2.0"
      date="14-10-2021"
    >
      <ul>
        <li>
          New configuration window for Chrono configuration in continuous
          studies
        </li>

        <li>
          Moving the location for opening the Area of Interest and Chrono
          settings
        </li>

        <li>Version alpha of Feature Check</li>

        <li>
          More confortable and responsive window for Area of Interest
          and Chrono config
        </li>

        <li>Pictures include file name as the title</li>
      </ul>

      <h4>Bugfixes</h4>

      <p>We have hunted these bugs:</p>

      <ul>
        <li>
          Fixing bug of multiple update of concentrations in processed
          data table
        </li>

        <li>
          Regex for DT6 data extraction in the backend more
          generalized
        </li>
      </ul>
    </Release>

    <Release
      version="1.1.9"
      date="3-10-2021"
    >
      <ul>
        <li>
          Configuration of the PDF export, now it supports A4 and add
          signature
        </li>

        <li>
          Independent Statistical Evaluation includes the title of the
          data line
        </li>

        <li>
          Adding first commands to the terminal: help, flipx, flipy, offsetx,
          offsety
        </li>
      </ul>
    </Release>

    <div class="background-style" />
  </div>
</template>

<script>
import Release from '@/components/releaseNotes/release';

export default {
  name: 'ReleaseNotes',
  metaInfo: {
    title: 'Release Notes – Djuli',
    meta: [{ name: 'description', content: 'Latest updates and release notes for the Djuli sensor data analysis platform.' }],
  },
  components: {
    Release,
  },
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin: auto;
  text-align: justify;
}

.background-style {
  width: 100%;
  height: 30vh;
  background-color: rgb(7, 167, 7);
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.main-title {
  color: white;
  padding-top: 0.5rem;
  font-size: 2rem;
}

.main-subtitle {
  color: white;
  padding-top: 0.5rem;
}

h1 {
  font-weight: bold;
}
</style>
